import { Injectable } from '@angular/core';
import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { startLoading, stopLoading } from '../store/ui/ui.actions';
import { NotificationService } from 'src/app/signalr/notification.service';

// Set on a request's HttpContext to keep it out of the global loading state (e.g. background polling).
// A context token, not a header, so nothing extra goes on the wire (no CORS preflight impact).
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    if (this.requests.length === 0) {
      this.store.dispatch(stopLoading());
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Background polls (sections zip job status every few seconds) would make the toolbar indicator blink.
    if (req.context.get(SKIP_LOADING)) {
      return next.handle(req);
    }

    this.requests.push(req);
    if (this.requests.length === 1) {
      this.store.dispatch(startLoading());
      
      // Opcionalmente, podemos adicionar uma notificação de carregamento
      // Se quisermos extrair informações da URL para a notificação, podemos usar:
      // const endpoint = req.url.split('/').pop();
      // this.notificationService.addInProgressNotification(`Carregando ${endpoint}`);
    }
    return next.handle(req).pipe(
      finalize(() => this.removeRequest(req))
    );
  }
} 